import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { BarMelding, BarMeldingType } from '@lvflanders/bar-ng';

const STATUS_TYPE_MAPPING = {
    BELANGRIJK: 'warning',
    OPGELOST: 'success',
    INFORMATIEF: 'info'
} as const;

@Component({
    selector: 'baas-melding',
    templateUrl: './baas-melding.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Represents a single melding */
export class BaasMelding {
    readonly #sanitizer = inject(DomSanitizer);

    readonly melding = input.required<BarMelding>();

    protected readonly sanitizedMeldingContent = computed(() => {
        return this.melding()?.content ? this.#sanitizer.bypassSecurityTrustHtml(this.melding().content) : null;
    });

    protected readonly iconClass = computed(() => {
        switch (this.melding()?.meldingType) {
            case BarMeldingType.Belangrijk:
                return 'fa-solid me-1 fa-sm fa-exclamation-triangle';
            case BarMeldingType.Informatief:
                return 'fa-solid me-1 fa-sm fa-info-circle';
            case BarMeldingType.Opgelost:
                return 'fa-solid me-1 fa-sm fa-check-circle';
            default:
                return null;
        }
    });

    protected readonly title = computed(() => {
        switch (this.melding()?.meldingType) {
            case BarMeldingType.Belangrijk:
                return 'Belangrijk';
            case BarMeldingType.Informatief:
                return 'Informatief';
            case BarMeldingType.Opgelost:
                return 'Opgelost';
            default:
                return 'Melding';
        }
    });

    protected readonly status = computed(() => {
        if (this.melding() && STATUS_TYPE_MAPPING[this.melding().meldingType]) {
            return `status-indicator--${STATUS_TYPE_MAPPING[this.melding().meldingType]}`;
        }
        return null;
    });
}
